import { apiInterfaceForJson } from '../common/apiManager';

// Scan and catalog CSV files
export const scanFiles = (storeFullData = true) => {
    const params = new URLSearchParams();
    params.append('storeFullData', storeFullData);
    return apiInterfaceForJson(`/legacy-viewer/v1/scan-files?${params.toString()}`, 'POST', {});
};

// Get list of all entities
export const getEntityList = () => {
    return apiInterfaceForJson('/legacy-viewer/v1/entities', 'GET');
};

// Get files for specific entity
export const getEntityFiles = (entityType) => {
    return apiInterfaceForJson(`/legacy-viewer/v1/entities/${encodeURIComponent(entityType)}/files`, 'GET');
};

// Read CSV data with pagination
export const readCSVData = (entityType, fileName, options = {}) => {
    const params = new URLSearchParams();

    if (options.page) params.append('page', options.page);
    if (options.limit) params.append('limit', options.limit);
    if (options.searchTerm) params.append('searchTerm', options.searchTerm);

    // Use database by default
    const useDatabase = options.useDatabase !== false;
    params.append('useDatabase', useDatabase);

    const queryString = params.toString();
    const url = `/legacy-viewer/v1/file-data/${encodeURIComponent(entityType)}/${encodeURIComponent(fileName)}${queryString ? '?' + queryString : ''}`;
    return apiInterfaceForJson(url, 'GET');
};

// Get file statistics
export const getFileStatistics = (fileName) => {
    return apiInterfaceForJson(`/legacy-viewer/v1/files/${encodeURIComponent(fileName)}/statistics`, 'GET');
};

// Search across all files
export const searchAcrossFiles = (searchTerm, options = {}) => {
    const params = new URLSearchParams();
    params.append('q', searchTerm);

    if (options.entityTypes && options.entityTypes.length > 0) {
        params.append('entityTypes', options.entityTypes.join(','));
    }
    if (options.limit) params.append('limit', options.limit);

    // Use database by default
    const useDatabase = options.useDatabase !== false;
    params.append('useDatabase', useDatabase);

    const queryString = params.toString();
    const url = `/legacy-viewer/v1/search${queryString ? '?' + queryString : ''}`;
    return apiInterfaceForJson(url, 'GET');
};

// Search within a specific file
export const searchInFile = (entityType, fileName, searchTerm, limit = 100, useDatabase = true) => {
    const params = new URLSearchParams();
    params.append('q', searchTerm);
    params.append('limit', limit);
    params.append('useDatabase', useDatabase);

    const queryString = params.toString();
    const url = `/legacy-viewer/v1/search-file/${encodeURIComponent(entityType)}/${encodeURIComponent(fileName)}${queryString ? '?' + queryString : ''}`;
    return apiInterfaceForJson(url, 'GET');
};

// Get entity relationships
export const getEntityRelationships = () => {
    return apiInterfaceForJson('/legacy-viewer/v1/relationships', 'GET');
};

// Export data
export const exportData = (entityType, fileName, format = 'json', options = {}) => {
    const params = new URLSearchParams();
    params.append('format', format);

    if (options.limit) params.append('limit', options.limit);

    // Use database by default
    const useDatabase = options.useDatabase !== false;
    params.append('useDatabase', useDatabase);

    const queryString = params.toString();
    const url = `/legacy-viewer/v1/export/${encodeURIComponent(entityType)}/${encodeURIComponent(fileName)}${queryString ? '?' + queryString : ''}`;

    return apiInterfaceForJson(url, 'GET');
};

// Check if data is stored in database
export const checkDataStorage = () => {
    return apiInterfaceForJson('/legacy-viewer/v1/check-storage', 'GET');
};

// Populate entity data
export const populateEntityData = (entityType) => {
    return apiInterfaceForJson(`/legacy-viewer/v1/populate-entity/${encodeURIComponent(entityType)}`, 'POST', {});
};

// Get entity population status
export const getEntityPopulationStatus = () => {
    return apiInterfaceForJson('/legacy-viewer/v1/entity-population-status', 'GET');
};
